import styled from "styled-components";
import { Plus, Minus } from "lucide-react";

const Control = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
  background-color: #f0f0f0;
  border-radius: 8px;
  padding: 2px;
`;

const StepButton = styled.button`
  min-width: 34px;
  min-height: 34px;
  padding: 6px;
  border: none;
  background: none;
  border-radius: 6px;
  cursor: pointer;
  color: #333;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background-color 0.15s;

  &:hover:not(:disabled) {
    background-color: #e0e0e0;
  }

  &:disabled {
    opacity: 0.3;
    cursor: not-allowed;
  }
`;

const Display = styled.span`
  min-width: 28px;
  text-align: center;
  font-size: 15px;
  font-weight: 600;
  color: #333;
`;

// Tap-only quantity control (no typing) shared by the HGS food + add-on carts. Mirrors the FNB
// menu-item stepper so the two ordering flows feel identical.
export const QuantityStepper = (props) => {
  const min = props.min === undefined ? 0 : props.min;

  return (
    <Control>
      <StepButton
        type="button"
        onClick={props.onDecrease}
        disabled={props.value <= min}
        aria-label="decrease"
      >
        <Minus size={15} />
      </StepButton>
      <Display>{props.value}</Display>
      <StepButton
        type="button"
        onClick={props.onIncrease}
        disabled={props.disabledIncrease || false}
        aria-label="increase"
      >
        <Plus size={15} />
      </StepButton>
    </Control>
  );
};
